<template>
  <div class="operateStep">
    <p class="title">{{ lang('操作流程') }}</p>
    <p class="name">{{ lang('通过推荐的银行汇款至我们的银行账户') }}</p>
    <div ref="myElement" class="image">
      <img
        v-for="(src, index) in images"
        :key="index"
        :src="src"
        :style="{ width: imageWidth, 'margin-right': imageMargin(index + 1) }"
      />
    </div>
    <p class="name">{{ lang('登录您的APP，创建充值申请单') }}</p>
    <p class="text">
      {{ lang('打开个人中心-我的钱包，找到预付款充值功能') }}
    </p>
    <p class="text">{{ lang('转账完毕后，填写转账申请，填写转账信息') }}</p>
    <p class="text">{{ lang('上传凭证') }}</p>
    <p class="text">{{ lang('提交申请') }}</p>
    <p class="name">
      {{ lang('我们的财务人员确认资金到账后，会通过充值申请，并为您充值') }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import lang from '@/langs'
import KBK from '@/assets/images/score/KBK.png'
import BKB from '@/assets/images/score/BKB.png'
import CTI from '@/assets/images/score/CTI.png'
import KTI from '@/assets/images/score/KTI.png'
import KGI from '@/assets/images/score/KGI.png'

import security from '@/assets/images/score/security.jpeg'
import PNG from '@/assets/images/score/PNG.jpeg'
import RCBC from '@/assets/images/score/RCBC.jpeg'
import eastwest from '@/assets/images/score/eastwest.jpeg'

const myElement = ref(null)
const imageWidth = ref(0 + 'px')
const images = [security, PNG, RCBC, eastwest]
const imageMargin = (i: number) => {
  if (i % 3 === 0) {
    return 0
  } else {
    return '10px'
  }
}
onMounted(() => {
  const elementWidth = myElement.value.getBoundingClientRect().width
  console.log('元素宽度:', elementWidth)
  imageWidth.value = (elementWidth - 20) / 3 + 'px'
})
</script>

<style scoped lang="less">
.operateStep {
  background: #fff;
  padding: 19px 16px;
  .title {
    color: rgba(60, 60, 60, 1);
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 24px;
  }
  .name {
    color: rgba(60, 60, 60, 1);
    font-size: 14px;
    margin-bottom: 10px;
  }
  .text {
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    margin-bottom: 7px;
  }
  .image {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 21px;
    img {
      margin-bottom: 10px;
    }
  }
}
</style>
